/**
 * Arcℏimedian DSaaS — Application Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppProviders } from './providers';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { FONTS_URL } from './theme';
import './i18n';
import './index.css';

// Load fonts
const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = FONTS_URL;
document.head.appendChild(link);

// Sentry (opt-in via VITE_SENTRY_DSN)
const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (sentryDsn) {
  import('@sentry/react').then(({ init, browserTracingIntegration }) => {
    init({
      dsn: sentryDsn,
      environment: import.meta.env.MODE,
      integrations: [browserTracingIntegration()],
      tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
      sendDefaultPii: false,
    });
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <AppProviders>
          <App />
        </AppProviders>
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);
